import {
  hexToRgb,
  mixColors,
  rgbToHex,
} from "../../infrastructure/utilities/colorUtility";
import { IBaseIconProps } from "./IBaseIconProps";

export const BackgroundGradient = ({
  color = "#000",
  backgroundColor,
}: IBaseIconProps) => {
  if (!backgroundColor || !color) {
    return null;
  }

  const light = hexToRgb(color);
  const dark = hexToRgb(backgroundColor);

  const c0 = rgbToHex(light.r, light.g, light.b);
  const c30 = rgbToHex(
    ...(Object.values(mixColors(light, dark, 0.25)) as [number, number, number])
  );
  const c60 = rgbToHex(
    ...(Object.values(mixColors(light, dark, 0.5)) as [number, number, number])
  );
  const c100 = rgbToHex(dark.r, dark.g, dark.b);

  return (
    <svg
      viewBox="0 0 800 600"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        position: "absolute",
        inset: 0,
        zIndex: -1,
        width: "100%",
        height: "100%",
      }}
    >
      <defs>
        <linearGradient id="baseGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={c0} />
          <stop offset="30%" stopColor={c30} />
          <stop offset="60%" stopColor={c60} />
          <stop offset="100%" stopColor={c100} />
        </linearGradient>
      </defs>
      <rect width="100%" height="100%" fill="url(#baseGradient)" />
    </svg>
  );
};
